import { api } from "../../lib";

export interface DiagnosisCategory {
  id: string;
  name: string;
  description: string | null;
  markerShape: string | null;
  markerColor: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDiagnosisCategoryInput {
  name: string;
  description?: string | null;
  markerShape?: string | null;
  markerColor?: string | null;
  isActive?: boolean;
}

export interface UpdateDiagnosisCategoryInput
  extends Partial<CreateDiagnosisCategoryInput> {
  id: string;
}

export const diagnosisCategoriesService = {
  getAll: async () => {
    return api.get<DiagnosisCategory[]>("/admin/diagnosis-categories");
  },

  getById: async (id: string) => {
    return api.get<DiagnosisCategory>(`/admin/diagnosis-categories/${id}`);
  },

  create: async (input: CreateDiagnosisCategoryInput) => {
    return api.post<DiagnosisCategory>("/admin/diagnosis-categories", input);
  },

  update: async (input: UpdateDiagnosisCategoryInput) => {
    const { id, ...updates } = input;
    return api.put<DiagnosisCategory>(
      `/admin/diagnosis-categories/${id}`,
      updates
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/diagnosis-categories/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<DiagnosisCategory>(`/admin/diagnosis-categories/${id}`, {
      isActive,
    });
  },
};
